module.exports = __webpack_public_path__ + "static/media/left_bg.b8b17d43.svg";